import { render, staticRenderFns } from "./date-item.vue?vue&type=template&id=f52606ac&scoped=true"
import script from "./date-item.vue?vue&type=script&lang=js"
export * from "./date-item.vue?vue&type=script&lang=js"
import style0 from "./date-item.vue?vue&type=style&index=0&id=f52606ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52606ac",
  null
  
)

export default component.exports